import React from "react";
import { Upload } from "antd";
import imgJson from "./json.png";

const { Dragger } = Upload;

const JsonFileImport = ({ setRaw, loading, setLoading, Loading }) => (
  <Dragger
    name={"file"}
    accept={".json"}
    multiple={false}
    maxCount={1}
    // disabled={loading}
    action={null}
    beforeUpload={(e) => {
      Loading(true);
      const reader = new FileReader();
      reader.readAsText(e);
      reader.onload = () => {
        // console.log("reader.result", JSON.parse(reader.result));
        setRaw(JSON.parse(reader.result));
        Loading(false);
      };
      return false;
    }}
  >
    <p className="ant-upload-drag-icon">
      <img src={imgJson} alt="" style={{ width: "5%" }} />
    </p>
    <p className="ant-upload-text">Cliquer ou déposer le fichier json</p>
    <p className="ant-upload-hint">
      Atttention seul les fichiers json sont pris en charge.
    </p>
  </Dragger>
);

export default JsonFileImport;
